import React, { useCallback, useEffect, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import Api from '../../../../_helpers/Api'
import Pagination from '../../../Pagination'
import Filter from './Filter'
import loader from '../../../../assets/img/loader.svg'
import NoDataFound from '../../../partials/NoDataFound'
import { trans } from '../../../../_providers/Translation'
import Skeleton from 'react-loading-skeleton'

let timeout

function Index(props) {

    const params = useParams()
    const location = useLocation()
    const history = useHistory()

    const searchParams = new URLSearchParams(location.search)

    const tabs = [
        {
            id: 'all',
            name: 'Всички',
            count: 0
        }
    ]

    const tab = searchParams.get('status_id') || tabs[0].id
    const categoryId = searchParams.get('category_id') || ''
    const supplierId = searchParams.get('supplier_id') || ''
    const name = searchParams.get('name') || ''

    const [state, setState] = useState({
        loading: true,
        page: 1,
        statuses: tabs,
        data: [],
        total: 0,
        pages: 0,
        filter: {
            status_id: tabs[0].id,
        },
        setFilter: false,
        update: false,
    })

    useEffect(() => {

        setState(prev => ({
            ...prev,
            page: searchParams.get('page') || 1,
            filter: {
                ...prev.filter,
                status_id: tab,
                category_id: categoryId,
                supplier_id: supplierId,
                name: name
            },
            update: new Date().getTime()
        }))
    }, [location.search])

    // useEffect(() => {
    //     console.log(state.filter);
    // }, [state.filter]);

    useEffect(() => {
        if (state.setFilter) {
            searchParams.set('page', state.page)

            Object.entries(state.filter).map(filter => {
                // if (filter[1]) {
                searchParams.set(filter[0], filter[1])
                // }
            })

            let url = '?' + searchParams.toString()

            history.push(url)
        }

    }, [state.setFilter])

    useEffect(() => {
        loadCounts()
    }, [state.filter.category_id, state.filter.supplier_id, state.filter.name])

    useEffect(() => {
        if (state.update) {
            loadData()
        }
    }, [state.update])

    const loadCounts = () => {

        let url = 'contractors/parts/count?id=' + params.id

        Object.entries(state.filter).map(filter => {
            url += '&' + filter[0] + '=' + filter[1]
        })

        Api.get(url)
            .then(res => {

                let statuses = tabs

                statuses[0].count = res.data.total

                statuses = statuses.concat(res.data.statuses)

                setState(prev => ({
                    ...prev,
                    statuses: statuses
                }))
            })
    }

    const loadData = () => {

        setState(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'contractors/parts' + '?id=' + params.id + '&page=' + state.page

        Object.entries(state.filter).map(filter => {
            url += '&' + filter[0] + '=' + filter[1]
        })

        Api.get(url)
            .then(res => {

                setState(prev => ({
                    ...prev,
                    data: res.data.items,
                    total: res.data.total,
                    pages: res.data.pages,
                }))
            })
            .finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const refreshData = () => {
        setState(prev => ({
            ...prev,
            update: new Date().getTime()
        }))
    }

    const handleTab = val => {

        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                status_id: String(val),
            },
            page: 1,
            setFilter: Math.random().toString(),
            loading: true
        }))

    }

    //Search
    const handleSearch = (key, val) => {
        clearTimeout(timeout)

        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                [key]: val,
            },
            page: 1,
        }))

        timeout = setTimeout(() => {
            setState(prev => ({
                ...prev,
                setFilter: new Date().getTime()
            }))
        }, 300)
    }

    const handlePage = page => {
        setState(prev => ({ ...prev, page: page.selected + 1, setFilter: Math.random().toString() }))
    }

    return (
        <div className='pannel'>

            <Filter
                filter={state.filter}
                tabs={state.statuses}
                tab={state.filter.status_id}
                handleTab={handleTab}
                handleSearch={handleSearch}
            />

            {state.loading
                ?
                <Skeleton height={45} count={10} />
                :
                state.data.length === 0
                    ?
                    <NoDataFound />
                    :
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    {trans('tables.status')}
                                </th>
                                <th>
                                    {trans('tables.name')}
                                </th>
                                <th>
                                    {trans('tables.number')}
                                </th>
                                <th>
                                    {trans('tables.refNo')}
                                </th>
                                <th>
                                    {trans('tables.address')}
                                </th>
                                <th className="right">
                                    {trans('tables.usedOn')}
                                </th>
                                <th className="center">
                                    {trans('tables.quantity')}
                                </th>
                                <th className="right">
                                    {trans('tables.price')}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {state.data.map(p =>
                                <tr key={'p-' + p.id}>
                                    <td>
                                        {p.status && p.status.translation ? p.status.translation.name : p.status.name}
                                    </td>
                                    <td>
                                        {p.name}
                                    </td>
                                    <td>
                                        {p.number || '-'}
                                    </td>
                                    <td>
                                        {p.reservation
                                            ?
                                            <a
                                                href={'/schedule/reservations/edit/' + p.reservation_id} target="_blank"
                                                className="btn"
                                                style={{ background: p.reservation.color, color: p.reservation.text_color }}
                                            >
                                                {p.reservation.reference_code}
                                            </a>
                                            :
                                            '-'
                                        }
                                    </td>
                                    <td>
                                        {p.reservation
                                            ?
                                            p.reservation.full_address
                                            :
                                            '-'
                                        }
                                    </td>
                                    <td className="right">
                                        {p.add_date}
                                    </td>
                                    <td className="center">
                                        {p.quantity}
                                    </td>
                                    <td className="right">
                                        {p.net_price_format} {p.currency.name}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
            }

            {!state.loading
                ?
                <Pagination
                    pages={state.pages}
                    page={state.page}
                    handlePage={handlePage}
                />
                :
                ''
            }
        </div>
    )
}

export default Index